import React, { useEffect, useState } from 'react';
import { SavingPlanReserveModel } from '../../../../services/finOps/FinOpsSavingPlanReserve/FinOpsSavingPlanReserveModel';
import LcLoading from '../../../../components/Generic/LcLoading';
import ReactECharts from 'echarts-for-react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store';
import { UserState } from '../../../../store/reducers/userReducer';

interface Props {
    data: SavingPlanReserveModel[];
    loading: boolean
    periodSelected: number;
}

interface chartModel {
    type: string;
    Azure: string;
    AWS: string

}

const MediaUsageChart: React.FC<Props> = (props) => {
    const user = useSelector<RootState, UserState>(state => state.user);
    const [chartData, setChartData] = useState<chartModel[]>([])

    const getChartParams = () => {
      const hoje = new Date();
      const mesAtual = hoje.getMonth();
      const anoAtual = hoje.getFullYear();

      const objetosFiltrados = props.data.filter(objeto => {
        const effectiveDateTime = new Date(objeto.effectiveDateTime);
        if (
          (props.periodSelected === 1 && effectiveDateTime.getMonth() === mesAtual && effectiveDateTime.getFullYear() === anoAtual) ||
          (props.periodSelected === 2 && effectiveDateTime.getMonth() === mesAtual - 1 && effectiveDateTime.getFullYear() === anoAtual) ||
          (props.periodSelected === 3)
        ) {
          return true;
        }
        return false;
      });
      
        let somatorioReservaAWS = 0;
        let somatorioReservaAzure = 0;
        let somatorioSavingPlanAWS = 0;
        let somatorioSavingPlanAzure = 0;
        let countReservaAWS = 0;
        let countReservaAzure = 0;
        let countSavingPlanAWS = 0;
        let countSavingPlanAzure = 0;

        for (const objeto of objetosFiltrados) {
          if (objeto.type.toLowerCase() === 'reserva' && objeto.provider.toLowerCase() === 'aws') {
            somatorioReservaAWS +=((objeto.used/objeto.reservations));
            countReservaAWS++;
          } else if (objeto.type.toLowerCase() === 'reserva' && objeto.provider.toLowerCase() === 'azure') {
            somatorioReservaAzure += ((objeto.used/objeto.reservations) );
            countReservaAzure++
          } else if (objeto.type.toLowerCase() === 'saving plan' && objeto.provider.toLowerCase() === 'azure') {
            somatorioSavingPlanAzure += ((objeto.used/objeto.reservations));
            countSavingPlanAzure++;
          } else if (objeto.type.toLowerCase() === 'saving plan' && objeto.provider.toLowerCase() === 'aws') {
            somatorioSavingPlanAWS += ((objeto.used/objeto.reservations) );
            countSavingPlanAWS++;
          }
        }

        return [
            { type: 'Saving Plan', Azure: ((somatorioSavingPlanAzure/countSavingPlanAzure) * 100  ).toFixed(1), AWS: ((somatorioSavingPlanAWS/ countSavingPlanAWS )* 100).toFixed(1) },
            { type: 'Reserva de instâncias', Azure: ((somatorioReservaAzure/ countReservaAzure) * 100).toFixed(1), AWS:((somatorioReservaAWS/ countReservaAWS) * 100).toFixed(1) },
        ]; 
    }

    useEffect(() => {
        setChartData(getChartParams());
    },[user.ClientGroupSelected, user.refreshFlag, props.data, props.periodSelected])

    const optionsChart = {
        grid: {
            top: 10,
            bottom: 5,
            left: 0,
            right: 70, 
            containLabel: true,
          },
        tooltip: {},
        dataset: {
          dimensions: ['type', 'Azure', 'AWS'],
          source: chartData,
        },
        xAxis: {
            type: 'category',
            show: true,
            axisLabel: {
            interval: 0,
            fontSize: 10
            }    
        },
        yAxis: {
          type: 'value',
          max: 100,
        },
        series: [
          { type: 'bar', name: 'Azure', itemStyle: { color: '#173192' } , barGap: 0, },
          { type: 'bar', name: 'AWS', itemStyle: { color: '#ff9900' } , barGap: 0,},
          
        ],
        legend: {
          data: ['Azure', 'AWS'],
          orient: 'vertical',
          top: 'middle',
          right: 10,
          itemWidth: 0,
          itemHeight:0,
          formatter: function (name) {
            if (name === 'Azure') {
                    return `{circleAzure|} {title|${name}}`;
                } else if (name === 'AWS') {
                    return `{circleAWS|} {title|${name}}`;
                }
          },
          textStyle: {
                rich: {
                    title: {
                        fontSize: 10,
                        color: '#a4a9b9'
                    },
                    circleAzure: {
                        width: 10,
                        height: 10,
                        borderRadius: 5,
                        backgroundColor:  "#173192",
                        align: 'center',
                        lineHeight: 14
                    },
                    circleAWS: {
                        width: 10,
                        height: 10,
                        borderRadius: 5,
                        align: 'center',
                        backgroundColor:  "#ff9900",
                        lineHeight: 14
                    }
                }
            }
        }
      };
      

    return (
        <LcLoading loading={props.loading} label='Carregando gráfico...'>
            <ReactECharts
                opts={{ renderer: 'svg', locale: 'PT-br' }}
                style={{maxHeight: '20vh'}}
                option={optionsChart}
            />
        </LcLoading>
    )
}

export default MediaUsageChart;